import api from './http';

export const TasksAPI = {
  list: (params = {}) => api.get('/tasks', { params }).then((response) => response.data),
  create: (payload) => api.post('/tasks', payload).then((response) => response.data),
  get: (id) => api.get(`/tasks/${id}`).then((response) => response.data),
  remove: (id) => api.delete(`/tasks/${id}`).then((response) => response.data),
  assign: (id, assignee) => api.patch(`/tasks/${id}/assign`, { assignee }).then((response) => response.data),
  setStatus: (id, status) => api.patch(`/tasks/${id}/status`, { status }).then((response) => response.data),
  setStage: (id, stage) => api.patch(`/tasks/${id}/stage`, { stage }).then((response) => response.data),
  workflow: (id, payload) => api.patch(`/tasks/${id}/workflow`, payload).then((response) => response.data),
  comment: (id, text) => api.post(`/tasks/${id}/comments`, { text }).then((response) => response.data),
  startViewSession: (id) => api.post(`/tasks/${id}/view-sessions`).then((response) => response.data),
  endViewSession: (id, payload) => api.patch(`/tasks/${id}/view-sessions/end`, payload).then((response) => response.data),
  productivityReport: (params = {}) => api.get('/tasks/reports/productivity', { params }).then((response) => response.data),
  addLink: (id, link) => api.post(`/tasks/${id}/links`, link).then((response) => response.data),
  syncExternalLink: (id, provider, payload = {}) => api.post(`/tasks/${id}/links/sync/${provider}`, payload).then((response) => response.data),
  getBlingReportHtml: (id, linkId) => api.get(`/tasks/${id}/links/bling-report`, {
    params: { linkId },
    responseType: 'text',
    headers: { Accept: 'text/html' }
  }).then((response) => response.data),
  linkOptions: (id, provider, params = {}) => api.get(`/tasks/${id}/link-options/${provider}`, { params }).then((response) => response.data),
  uploadOneDriveLink: (id, { type, label, file }) => api.post(`/tasks/${id}/links/upload/onedrive`, file, {
    params: {
      type,
      label,
      fileName: file?.name || 'arquivo'
    },
    headers: {
      'Content-Type': file?.type || 'application/octet-stream'
    }
  }).then((response) => response.data),
  kpis: () => api.get('/tasks/kpis/overview').then((response) => response.data),
};
